import Introduction from "../../componets/Introduction";

export default function Section2() {
  return (
    <div className="Section2">
      <Introduction
        title="Introduction"
        text="AI has significantly impacted the e-commerce industry, revolutionizing the way businesses operate and customers shop online. Building a website that incorporates AI technologies can enhance user experiences, streamline operations, and drive sales."
        divider={true}
      />

      <div className="w-[90%] my-[24px] md:my-0 md:w-[61%] mx-auto text-center">
        <h2 className="text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] my-[0.67em]">
          Solutions To Support Every Use Case
        </h2>

        <p className="pt-[1%] w-[75%] mx-auto leading-[20px] text-[#535353] font-open text-[16px]">
          Mean3 offers exceptional Staff Augmentation services for critical IT
          to help you scale and optimize your project development process.
        </p>
      </div>
    </div>
  );
}
